module.exports = __webpack_public_path__ + "static/img/logo.7c98fcbe.svg";